import React, { useEffect } from 'react'
import { Input } from '@st-operations/uikit/src/v2'

import { useEventFeedsContext } from '../../../context/index.jsx'
import pretty from '@st-operations/uikit/lib/pretty.js'

const SOURCES = ['sharethis', 'sovrn', 'sovrneu']

const DataSourceForm = () => {
  const {
    data: { deliveries, filters },
    dispatch,
    ACTIONS,
  } = useEventFeedsContext()
  const delivery = deliveries[0] ?? {}

  const getSources = () => {
    if (filters.some((filter) => filter.key === 'source')) {
      const selectedSources = filters.find((filter) => filter.key === 'source').value

      return SOURCES.filter((source) => selectedSources.includes(source))
    }

    return SOURCES
  }

  const sources = getSources()

  const handleFormChange = (value, name) => {
    dispatch({
      type: ACTIONS.UPDATE_DELIVERY,
      payload: {
        datasourceSampling: {
          ...delivery.datasourceSampling,
          [name]: parseFloat(value),
        },
      },
    })
  }

  // // Make sure delivery has values for all data sources
  useEffect(() => {
    // Check filters to see if it should be added or not
    const sampling = sources.reduce((acc, source) => {
      return { ...acc, [source]: delivery.datasourceSampling?.[source] ?? 1 }
    }, {})

    if (delivery?.datasourceSampling) return

    dispatch({
      type: ACTIONS.UPDATE_DELIVERY,
      payload: {
        datasourceSampling: {
          ...sampling,
        },
      },
    })
  }, [delivery.datasourceSampling, filters])

  return (
    <section className="data-source-form">
      <h1 className="data-source-form__title">Sampling</h1>
      <For each="source" of={sources}>
        <div className="data-source-form__group">
          <span>{pretty(source)}</span>
          <Input
            name={source}
            value={delivery?.datasourceSampling?.[source] ?? 1}
            type="number"
            min="0"
            max="1"
            step="0.05"
            onChange={handleFormChange}
          />
        </div>
      </For>
    </section>
  )
}

export default DataSourceForm
